import { Input } from "@/components/ui/input";
import { digits, formatNational } from "@/lib/phone";

/** Country code box (+1–3 digits) and a "xxx xxx xx xx" number box, like <PhoneNumberInput> in the Blazor UI. */
export function PhoneInput({
  id,
  countryCode,
  national,
  onChange,
  invalid,
}: {
  id: string;
  countryCode: string;
  national: string;
  onChange: (countryCode: string, national: string) => void;
  invalid?: boolean;
}) {
  return (
    <div className="flex gap-2">
      <div className="relative w-24 shrink-0">
        <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-muted-foreground">
          +
        </span>
        <Input
          aria-label="Country code"
          inputMode="numeric"
          className="pl-6"
          maxLength={3}
          value={countryCode}
          aria-invalid={invalid || undefined}
          onChange={(e) => onChange(digits(e.target.value).slice(0, 3), national)}
        />
      </div>
      <Input
        id={id}
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        placeholder="xxx xxx xx xx"
        value={formatNational(national)}
        aria-invalid={invalid || undefined}
        onChange={(e) => onChange(countryCode, digits(e.target.value).slice(0, 10))}
      />
    </div>
  );
}
